import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { getJSON, postJSON } from '../util';
import { waitForPendingProduct } from './tarot-reading';

export function* submit({ payload }) {
    const [ upc, user ] = yield all([
        select(state => state.product.teeup && state.product.teeup.code),
        select(state => state.user),
    ]);

    if (!user.logged_in) {
        yield all([
            put({
                type: 'product:update',
                payload: {
                    pending: true,
                },
            }),
            put({
                type: 'route:to',
                payload: 'login',
            }),
            take('user:logged-in'),
        ]);
    }

    yield call(waitForPendingProduct);

    if (upc) {
        yield put({
            type: 'form:update',
            payload: {
                submitting: true,
            },
        });

        let birthDate, forecastDate;
        // handle select fields
        if (!/^\d{4}[-]\d{2}[-]\d{2}$/.test(payload[3].value)) {
            birthDate = `${payload[5].value}-${payload[3].value}-${payload[4].value}`;
            forecastDate = `${payload[7].value}-${payload[6].value}-01`;
        } else {
            birthDate = payload[3].value;
            forecastDate = `${payload[4].value}-01`;
        }

        const inputs = {
            birth_name: payload[0].value,
            name: payload[1].value,
            gender: payload[2].value,
            birth_date: birthDate,
            forecast_date: forecastDate,
        };

        try {
            const order = yield call(postJSON, `/api/product/submit/${upc}`, inputs);
            yield put({ type: 'location:href', payload: order.forwarding_url });
        } catch(e) {
            yield put({
                type: 'form:update',
                payload: {
                    submitting: false,
                    error: 'Sorry, an error occurred',
                },
            });
        }
    }
}

export function* getStates({ payload }) {
    if (payload) {
        const country = yield call(getJSON, `/api/location/country/${payload.country_id}`);
        const states = yield call(getJSON, `/api/location/states/${payload.country_id}`);

        if (Object.keys(states).length) {
            yield put({
                type: 'location:update',
                payload: {
                    [`${payload.prefix}_states`]: states,
                    [`${payload.prefix}_country`]: country,
                },
            });
        } else {
            yield all([
                put({
                    type: 'product:get-cities',
                    payload: {
                        prefix: payload.prefix,
                        country_id: payload.country_id,
                        state_id: null,
                    },
                }),
                put({
                    type: 'location:update',
                    payload: {
                        [`${payload.prefix}_country`]: country,
                        [`${payload.prefix}_states`]: null,
                    },
                }),
            ]);
        }
    }
}

export function* getCities({ payload }) {
    if (payload) {
        let url = `/api/location/cities/${payload.country_id}`;
        if (payload.state_id) {
            url = `${url}/${payload.state_id}`;
        }

        const cities = yield call(getJSON, url);

        yield put({
            type: 'location:update',
            payload: {
                [`${payload.prefix}_cities`]: cities,
            },
        });
    }
}

export function* getLocation({ payload }) {
    if (payload) {
        let url = null;

        if (payload.city_id) {
            url = `/api/location/city/${payload.city_id}`;
        } else if (payload.city_name && payload.state_name && payload.country_name) {
            url = `/api/location/city/${payload.city_name}/${payload.state_name}/${payload.country_name}`;
        }

        if (url) {
            const data = yield call(getJSON, url);
            const profile = yield select(state => state.user && state.user.selected_profile);

            if (data && Object.keys(data).length) {
                const new_profile = {
                    ...profile,
                    ...{
                        [`${payload.prefix}_country_id`]: data.country_id,
                        [`${payload.prefix}_state_id`]: data.state_id,
                        [`${payload.prefix}_city_id`]: data.city_id,
                    },
                };

                yield put({
                    type: 'user:update',
                    payload: { selected_profile: new_profile },
                });
            }
        }
    }
}

export function* root() {
    yield all([
        takeEvery('product:submit', submit),
        takeEvery('product:get-states', getStates),
        takeEvery('product:get-cities', getCities),
        takeEvery('product:get-location', getLocation),
    ]);
}
